import { render } from "./loadingModal.vue?vue&type=template&id=805d57f4&scoped=true"
const script = {}

import "./loadingModal.vue?vue&type=style&index=0&id=805d57f4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-805d57f4"]])

export default __exports__